import React from 'react';
import LearnerLayout from '@/components/LearnerLayout';
import { Card, CardContent } from '@/components/ui/card';
import { Info, Phone, Mail, MapPin, Globe, Award, Shield } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const LearnerAProposPage = () => {
  const { t } = useLanguage();
  return (
    <LearnerLayout>
      <div className="space-y-6 max-w-3xl" data-testid="learner-apropos-page">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
            <Info className="h-6 w-6 text-teal-500" />
            {t('about_title')}
          </h1>
          <p className="text-slate-500 mt-1">{t('about_subtitle')}</p>
        </div>

        <Card className="overflow-hidden">
          <div className="bg-gradient-to-r from-[#0a3d62] to-[#38ada9] p-8 text-white">
            <div className="flex items-center gap-4 mb-4">
              <img src="/affea-logo.png" alt="AFFEA" className="w-16 h-16 rounded-xl object-cover bg-white/20 p-1" />
              <div>
                <h2 className="text-2xl font-bold">AFFEA</h2>
                <p className="text-white/80 text-sm">Académie Francophone de la Formation, de l'Enseignement et de l'Accompagnement</p>
              </div>
            </div>
          </div>
          <CardContent className="p-6 space-y-6">
            <div>
              <h3 className="font-semibold text-slate-900 mb-2">{t('about_mission')}</h3>
              <p className="text-slate-600 leading-relaxed">
                {t('about_missionText')}
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              <div className="flex items-start gap-3 p-4 bg-teal-50 rounded-xl">
                <Award className="h-6 w-6 text-teal-600 shrink-0 mt-0.5" />
                <div>
                  <p className="font-medium text-slate-900">{t('about_qualiopi')}</p>
                  <p className="text-sm text-slate-600 mt-1">{t('about_qualiopiDesc')}</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-blue-50 rounded-xl">
                <Shield className="h-6 w-6 text-blue-600 shrink-0 mt-0.5" />
                <div>
                  <p className="font-medium text-slate-900">{t('about_accessibility')}</p>
                  <p className="text-sm text-slate-600 mt-1">{t('about_accessibilityDesc')}</p>
                </div>
              </div>
            </div>

            <div className="border-t pt-6">
              <h3 className="font-semibold text-slate-900 mb-4">{t('about_contact')}</h3>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center">
                    <Mail className="h-4 w-4 text-slate-600" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-500">Email</p>
                    <p className="text-slate-900">president@affea.fr</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center">
                    <Phone className="h-4 w-4 text-slate-600" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-500">Téléphone</p>
                    <p className="text-slate-900">06 03 04 39 13</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center">
                    <Globe className="h-4 w-4 text-slate-600" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-500">Site web</p>
                    <a href="https://affea.fr" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline">affea.fr</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="border-t pt-6">
              <h3 className="font-semibold text-slate-900 mb-2">{t('about_handicap')}</h3>
              <p className="text-slate-600">M. NGOUPAYOU Amos</p>
              <p className="text-sm text-slate-500 mt-1">Pour toute question liée à l'accessibilité de nos formations, n'hésitez pas à nous contacter.</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </LearnerLayout>
  );
};

export default LearnerAProposPage;
